module.exports = __webpack_public_path__ + "img/bannerShort.943c420f.png";